export default __webpack_public_path__ + "static/media/Brexin.a248c469.jpg";